import { GetMarketplaceListRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const MARKETPLACES_API_PATHS = {
    ALL_MARKETPLACES: '/marketplaces',
}

class MarketplacesApi extends ApiBase {
    async allMarketplaces() {
        const response = await this._getRequest<GetMarketplaceListRequest>(MARKETPLACES_API_PATHS.ALL_MARKETPLACES)

        return response
    }
}

export default MarketplacesApi
